import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Switch } from '@material-ui/core';
import GeozonesMap from '../Geozone/GeozonesMap';
import {
  HeaderContainer, HeaderTitle, BackButton,
  BounceAnimatedContainer, PaperContainer,
} from '../../healtheraComponents';
import * as actions from '../../redux/geozones';
import { useSelector, useDispatch } from 'react-redux';


const ECommerceGeofenceMap = () => {
  const history = useHistory();
  const [showPins, setShowPins] = useState(true);
  const dispatch = useDispatch();
  const { otcPharmacies: pharmacies } = useSelector(state => state.geozones);
  
  useEffect(() => {
    dispatch(actions.getOtcPharmaciesGeofences());
  }, [dispatch]);

  const goBack = () => history.push(`${process.env.PUBLIC_URL}/regions`);
  const onClick = id => history.push(`${process.env.PUBLIC_URL}/branches/${id}`);

  return (
    <BounceAnimatedContainer>
      <HeaderContainer
        padding={`20px 0 20px 0`}
        onClick={goBack}
        borderbottom={`none`}
        p={2}
        align="center"
      >
        <BackButton padding={`0 5px 0 0`} />
        <HeaderTitle cursor={`pointer`} px={2} w={1 / 3}>
          Regions
        </HeaderTitle>
      </HeaderContainer>
      <PaperContainer elevation={0}>
        <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
          <HeaderTitle fontSize={`24px`}>E-Commerce Pharmacies</HeaderTitle>
        </HeaderContainer>
        <br />
        <GeozonesMap
          pharmacies={pharmacies}
          withMarker={showPins}
          withPaidDeliverySplit={true}
          onClickPolygon={onClick}
          onClickMarker={onClick}
        />
        <br />
        <br />
        <div>
          Show all the pins
          <Switch value={showPins} checked={showPins} onChange={() => setShowPins(!showPins)} />
        </div>
      </PaperContainer>
    </BounceAnimatedContainer>
  );
};

export default ECommerceGeofenceMap;
